import React from 'react';
import ProductPage from '../components/ProductPage';
import useDocumentTitle from '../hooks/useDocumentTitle';
import PrzyciskAsystenta from '../components/kreator/PrzyciskAsystenta';
import { useTranslation } from 'react-i18next';

const Magazines = () => {
  const { t } = useTranslation('lista');
  useDocumentTitle(t('tytul_strony.magazyn'));
  return (
    <div className='space-y-10'>
      <ProductPage
        productType="magazyn"
        akcja={(
          <PrzyciskAsystenta
            to="/dobor-magazynu"
            tytul={t('asystent.magazyn')}
            narzedzie={t('asystent.narzedzie')}
          />
        )}
      />
    </div>
  )
}

export default Magazines;
